export const app = {
	loading: {
		bootstrap: 'Please Wait, Starting The Blueprint Tool...',
		bootstrapError: 'Error Starting The Blueprint Tool, Please try again later.',
		saving: 'Saving Blueprint...'
	},
	tooltips: {
		clickToSelect: 'click to select'
	}
};
